import apiFetch from '../../apiFetch'

export default function (dossierId, organizedUnitId, token) {
  return apiFetch({ endPoint: `Dossier/ChangeUoDossier/${organizedUnitId}/${dossierId}`, method: 'GET', token: token })
}
